import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal } from "react-bootstrap";
import { Helmet } from "react-helmet";
import i18n from "../../../../i18n";
import BudgetMiddleware from "../../../../middleware/modules/accounting/budget";
import BudgetForm from "../../../../components/modules/accounting/budget/form";

const FormBudget = (props) => {
  const dispatch = useDispatch();
  const formRef = useRef(null);

  // Ambil data dari Redux
  const {
    isProcessing,
    isError,
    isSuccess,
    errorMessage,
    showModal,
    titleModal,
    onSubmit,
    helperBudget,
    isNewRecord,
  } = useSelector((state) => ({
    isProcessing: state.budget.isProcessing,
    isError: state.budget.isError,
    isSuccess: state.budget.isSuccess,
    errorMessage: state.budget.errorMessage,
    showModal: state.budget.showModal,
    helperBudget: state.budget.helperBudget,
    titleModal: state.budget.titleModal,
    onSubmit: state.budget.onSubmit,
    isNewRecord: state.budget.isNewRecord,
  }));

  // 🔹 Fungsi tutup modal
  const handleClose = () => {
    dispatch(BudgetMiddleware.reset());
  };

  // 🔹 Fungsi submit
  const handleSubmit = () => {
    const search = { limit: 10 };
    if (formRef.current) {
      const form = formRef.current.runSubmit();
      dispatch(BudgetMiddleware.beforeSaveNew(form, search));
    }
  };

  return (
    <>
      <Modal show={showModal} size="xl" enforceFocus={false}>
        <Modal.Header>
          <Modal.Title>{titleModal}</Modal.Title>
        </Modal.Header>

        <Helmet>
          <title>{titleModal}</title>
        </Helmet>

        <Modal.Body>
          <BudgetForm
            {...props}
            ref={formRef}
            isProcessing={isProcessing}
          />
        </Modal.Body>

        <Modal.Footer
          className={!onSubmit ? "justify-content-between" : "justify-content-center"}
        >
          {!onSubmit && (
            <Button variant="secondary" onClick={handleClose}>
              {i18n.t("Close")}
            </Button>
          )}
          <Button
            variant="primary"
            onClick={() => (!onSubmit ? handleSubmit() : null)}
          >
            {onSubmit ? (
              <span className="indicator-progress show">
                {i18n.t("Please wait...")}
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            ) : (
              <span className="indicator-label">{i18n.t("Save")}</span>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FormBudget;
